module.exports = __webpack_public_path__ + "ee4193cbb02c504006d2a6c73d1bd46f.pdf";